import React, { useState, useEffect } from "react";

import BeatLoader from "react-spinners/BeatLoader";
import Chip from '@material-ui/core/Chip';
import swal from 'sweetalert'
import GridContainer from "components/Grid/GridContainer.js";
import GridItem from "components/Grid/GridItem.js";
import Divider from '@material-ui/core/Divider';

import { halfSpace } from "@persian-tools/persian-tools";

import styles from "assets/jss/material-kit-react/views/learningPage.js";
import Axios from "axios";
import Config from "../../../../config.js"
import Card from '@material-ui/core/Card';
import CardActionArea from '@material-ui/core/CardActionArea';
import CardActions from '@material-ui/core/CardActions';
import CardContent from '@material-ui/core/CardContent';
import CardMedia from '@material-ui/core/CardMedia';
import Typography from '@material-ui/core/Typography';
import Button from '@material-ui/core/Button';
// @material-ui/core components
import { makeStyles } from "@material-ui/core/styles";
import {
  useHistory
} from "react-router-dom";

import { Helmet } from 'react-helmet'

const useStyles = makeStyles(styles);

export default function Products(props) {

  let [loading, setLoading] = useState(true);
  let [offCode, setOffCode] = useState("");
  const [products, setProducts] = useState(null);
  let history = useHistory();
  useEffect(() => {
    setLoading(true)
    Axios.post(Config.api + "Product/GetProducts", {
      tags: props.tags
    },
      {
        headers: {
          apikey: Config.apikey,
          Authorization: (localStorage.getItem('token')) ? "Bearer " + localStorage.getItem('token') : ""

        }
      }).then(async (result) => {
        setLoading(false)

        console.log(result)
        setProducts(result.data.data);
      }).catch((err) => {


        if (err && err.response && err.response.status && err.response.status === 401) {
          localStorage.removeItem('token');
          props.history.push("/SignIn");
          setLoading(false)
        }
        else if (err && err.response && err.response.status && err.response.status === 422) {
          swal("اطلاعات ارسالی نادرست است.");
          setLoading(false)
        }
        else if (err && err.response && err.response.status && err.response.status === 409) {
          swal("اطلاعات ارسالی نادرست است.");
          setLoading(false)
        }
        else if (err && err.response && err.response.data && err.response.data.message && err.response.data.message.pr) {
          setLoading(false)
          swal(err.response.data.message.pr);
        }
        else {
          // swal("خطایی رخ داده است. لطفا اتصال اینترنت را بررسی کنید.")
        }
      })
  }, []);
  function Log() {
    history.push("/Courses/Logs");
  }
  function ContactUs() {
    window.open(
      '/ContactUs',
      '_blank' // <- This is what makes it open in a new window.
    );
  }
  function Details(id, name) {
    history.push("/Courses/Details/" + id);
  }
  function OnlinePayment() {
    if (localStorage.getItem('token')) {
      window.open(
        'https://idpay.ir/sharifcamp',
        '_blank' // <- This is what makes it open in a new window.
      );
    } else {
      swal("لازم است ابتدا در سامانه وارد شوید.").then(() => {
        window.location.href = "/SignIn"
      })
    }
  }
  function PayAndGo(product) {
    swal("کد تخفیف دارید؟", {
      content: {
        element: "input",
        attributes: {
          placeholder: "کد تخفیف خود را وارد کنید.",
        },
      },
      buttons: ['کد تخفیف ندارم', 'اعمال کد تخفیف']
    }).then((value) => {
      if (value == "") {
        return swal("کد تخفیف خود را وارد کنید.");
      }
      offCode = value
      swal("در حال انتقال به بانک", {
        allowEscapeKey: false,
        allowOutsideClick: false,
        buttons: false,
        allowOutsideClick: false
      })
      var data = {
        productIds: [product],
        redirectUrl: "Courses/ZarinPal/Verify",
      };
      if (offCode)
        data.offCode = offCode;

      Axios.post(Config.api + "Product/Buy/Start", data,
        {
          headers: {
            apikey: Config.apikey,
            Authorization: "Bearer " + localStorage.getItem('token')

          }
        }).then((result) => {
          swal("مبلغ قابل پرداخت جهت ثبت نام: " + result.data.data.Total + " تومان", {
            buttons: ['برگشت', 'پرداخت'],
          }).then((value) => {
            if (value)
              window.location.href = (result.data.data.Url)
          })
        }).catch(err => {
          console.log(err)
          if (err && err.response && err.response.status && err.response.status === 401) {
            localStorage.removeItem('token');
            swal("لازم است ابتدا در سامانه وارد شوید.").then(() => {
              window.location.href = "/SignIn"//props.history.push("/SignIn");
            })
          }
          else if (err && err.response && err.response.status && err.response.status === 422)
            swal("اطلاعات ارسالی نادرست است.");
          else if (err && err.response && err.response.status && err.response.status === 409) {
            swal("اطلاعات ارسالی نادرست است.");
          }
          else if (err && err.response && err.response.data && err.response.data.message && err.response.data.message.pr)
            swal(err.response.data.message.pr);
          else swal("خطایی رخ داده است.")
        })
    })
  }
  const classes = useStyles();
  return (
    <div className={classes.container}>
      {
        (props.show != "hide") ?
          <Helmet>
            <title>{"کمپ آموزشی شریف (sharifcamp) | " + props?.tags}</title>
            <meta name="description" content={"دوره های ما با توجه اساتید خبره و مجرب ارائه خواهند شد. در پایان هر دوره مدرک معتبر با ارزیابی ارائه میگردد."} />
            <meta name="keywords" content={["Product", "Classes", "sharifcamp", "Programming", "C++", "C#", "NODEJS", "HCNA", "CCNA", "Linux"]} />
          </Helmet>
          : <></>
      }
      <div className={classes.center + " " + classes.fastAccess}>
        <BeatLoader loading={loading} color={"gray"} size={15} />
      </div>

      <GridContainer justify="left" className={classes.box} >

        {products && products.map((product, index) => {
          return (
            <GridItem xs={12} sm={12} md={3}>
              <Card variant="outlined" className={classes.card + " " + classes.right}>
                <CardActionArea onClick={() => Details(product.shortId, product.title)}>
                  <CardMedia
                    component="img"
                    alt={halfSpace(product.title)}
                    height="140"
                    image={product.logo}
                    title={halfSpace(product.title)}
                  />
                  <CardContent className={classes.cardContent}>
                    <div className={classes.cardTitle}>
                      <Typography gutterBottom variant="button" >
                        {product.title && product.title.split('\n').map(str => <p>{str.length > 1 ? str : <br />}</p>)}
                      </Typography>
                    </div>
                    <Typography className={classes.justify + " " + classes.right} variant="caption" color="textSecondary" >
                      {product.summary && halfSpace(product.summary).split('\n').map(str => <p>{str.length > 1 ? str : <br />}</p>)}
                    </Typography>
                    <div>
                      {product.price > 0 ?
                        <Button className={classes.priceText} disabled size="small" color="primary">
                          قیمت {product.price.toLocaleString('fa-ir')} تومان
                        </Button> :
                        <Button className={classes.priceText} disabled size="small" color="primary">
                          قیمت: تماس بگیرید
                        </Button>
                      }
                      <br />
                    </div>
                  </CardContent>
                  <Divider />
                </CardActionArea>
                <CardActions>

                  <div className={classes.left + " " + classes.cardBtn}>
                    <div>
                      <Button onClick={() => Details(product.shortId, product.title)} size="small" color="primary">
                        توضیحات و سرفصل
                      </Button>
                    </div>
                    { /*<Button onClick={() => ContactUs()} size="small" color="primary">
                      زمان برگزاری (تماس بگیرید)
                    </Button>*/
                    }
                    {(() => {
                      if (!product.bought) {

                        if (product.price > 0)
                          return (
                            ///*PayAndGo(product._id)*/
                            //OnlinePayment()
                            <Button onClick={() => PayAndGo(product._id)} size="small" color="primary">
                              پیش ثبت نام و پرداخت آنلاین
                            </Button>)
                        else
                          return (
                            <Button onClick={() => ContactUs()} size="small" color="primary">
                              ثبت نام (تماس بگیرید)
                            </Button>)

                      }
                      else {
                        return (
                          <div>
                            <Button onClick={() => Log()} size="small" color="primary">
                              مشاهده وضعیت
                            </Button>
                          </div>
                        )
                      }
                    })()}

                  </div>
                </CardActions>
              </Card>
            </GridItem>
          )
        })}
      </GridContainer>
      <div className={classes.description}>
        <p>
          {" "}
        </p>
      </div>
      <GridContainer justify="center">
      </GridContainer>
    </div>
  );
}